import React from 'react'
import '../login/login.scss'
const Login = () => {
  return (
    <div>Login</div>
  )
}

export default Login